import { Box, Tooltip, Typography } from '@mui/material';
import RewardProgress from './RewardProgress';

const ScoreColumn = ({ label, description, value, centered = false }) => (
  <Tooltip title={description}>
    <Box
      aria-label={`${description}: ${value ?? 'unavailable'}`}
      sx={{
        display: 'grid',
        gridTemplateRows: 'var(--score-label-height) var(--score-value-height)',
        rowGap: 0.5,
        textAlign: centered ? 'center' : 'left',
        minWidth: 0,
      }}
    >
      <Typography component="div" sx={{ alignSelf: 'center', fontSize: { xs: 6, sm: 9 }, color: 'primary.main', whiteSpace: 'nowrap' }}>
        {label}
      </Typography>
      <Typography component="div" sx={{ alignSelf: 'center', fontSize: { xs: 'clamp(8px, 2.3vw, 10px)', sm: 16 }, lineHeight: 1, color: 'text.primary', fontVariantNumeric: 'tabular-nums' }}>
        {value == null ? '--' : String(value).padStart(6, '0')}
      </Typography>
    </Box>
  </Tooltip>
);

const ArcadeScoreboard = ({ todayPoints, highScore, rewardPoints, rewardThreshold }) => (
  <Box
    id="app-points"
    sx={{
      '--score-label-height': { xs: '16px', sm: '24px', md: '28px' },
      '--score-value-height': { xs: '20px', sm: '24px', md: '28px' },
      display: 'grid',
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
      alignItems: 'center',
      gap: { xs: 0.5, sm: 1.5 },
      flex: 1,
      minWidth: 0,
      px: { xs: 0.75, sm: 1.5 },
      py: 0.75,
      border: '1px solid',
      borderColor: 'primary.main',
      borderRadius: '12px',
      background: theme => `linear-gradient(135deg, ${theme.palette.background.paper}, ${theme.palette.background.default})`,
    }}
  >
    <ScoreColumn label="POINTS" description="Points today" value={todayPoints} />
    <ScoreColumn label="HI SCORE" description="Best daily points" value={highScore} centered />
    <RewardProgress current={rewardPoints} total={rewardThreshold} />
  </Box>
);

export default ArcadeScoreboard;
